module.exports = __webpack_public_path__ + "static/img/3.bd6744f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R32/3.jpg
// module id = Qw2i
// module chunks = 1